export default {
	"Become a participant of the event": "Примите участие в мероприятии",
	"Until the beginning remained": "До начала осталось",
	"days": "дней",
	"hours": "часов",
	"minutes": "минут",
	"seconds": "секунд",

	"Add": "Добавить",
	"All fields are required": "Все поля обязательны к заполнению",
	"Attempting multiple users to access the same account. Try reload page": "Попытка доступа нескольких пользователей по одниму аккаунту. Перезагрузите страницу",
	"Chat": "Чат",
	"Close": "Закрыть",
	"Company information": "Сведения о компании",
	"Confirmation of registration": "Подтверждение регистрации",
	"Contact person": "Контактное лицо, ответственное за оформление участников",
	"Country": "Страна",
	"Downloads": "Материалы для загрузки",
	"Enter your message": "Введите сообщение",
	"Entrance": "Вход",
	"Enter": "Войти",
	"Error": "Ошибка",
	"First name": "Имя",
	"Last name": "Фамилия",
	"Legal company name": "Юридическое название компании",
	"Login": "Логин",
	"Logout": "Выход",
	"Cabinet": "Кабинет",
	"MyCabinet": "Мой кабинет",
	"Logout from online broadcast": "Выход из онлайн трансляции",
	"Middle name": "Отчество",
	"Participants registration": "Регистрация участников",
	"Participant": "Участник",
	"Participation format": "Формат участия",
	"Password": "Пароль",
	"Phone": "Телефон",
	"Please register as a participant": "Просим зарегистрировать в качестве участника",
	"Poll": "Опрос",
	"Position": "Должность",
	"Post address": "Почтовый адрес",
	"Prefered language": "Предпочтительный язык общения",
	"Promo code (if any)": "Промо-код (если есть)",
	"Registration": "Регистрация",
	"Remove": "Удалить",
	"Send": "Отправить",
	"Tax code": "Код ОКПО",
	"To enter the broadcast, use your personal link received from the conference organizers": "Для входа в трансляцию воспользуйтесь Вашей персональной ссылкой, полученной от организаторов конференции",
	"Total payment": "Итого к оплате",
	"Video": "Видео",
	"Your application is being processed": "Ваша заявка обрабатывается",
	"If you have not received confirmation of registration within a day contact the organizers": "Если Вы не получили подтверждение о регистрации в течение суток свяжитесь с организаторами",

	"Belarus": "Белорусь",
	"Kazakhstan": "Казахстан",
	"Russia": "Россия",
	"Uzbekistan": "Узбекистан",
	"Ukraine": "Украина",
	"materialsPDF": "Материалы в формате PDF",
	"promo": "Видео конференции",
// 	"": "",
};
